import { render } from "./ScrollbarPage.vue?vue&type=template&id=af0715d0&ts=true"
import script from "./ScrollbarPage.vue?vue&type=script&lang=ts"
export * from "./ScrollbarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__